ApplePayUI = require '../../frontend/'
{getLegalDisclaimerText} = require '../../frontend/helpers'
ApplePay = window.ApplePay = {}

getTotalAmount = ->
  $('.option input[name=option]:checked')
    .next('label')
    .find('.breakout-option-price')
    .text()

renderApplePayFeature = ->
  getApplePayButton()
    .after '<div class="applepay-promo-code"><a href="#applepay">'+I18n.t('js.modules.applepay.enter_promo_code_or_gift_code')+'</a></div>'
    .before "<span class='applepay-legal-disclaimer'>#{getLegalDisclaimerText('desktop')}</span>"
    .addClass('applepay-button')
    .html '<span class="applepay-logo" data-bhw="ApplePayButton"></span>'

  updatePromoCode()

getApplePayButton = ->
  $('.buy-button:not(:disabled)')

getConfirmationUrl = ->
  $('.option input[name=option]:checked').val()

updatePromoCodeHandler = ->
  $('.option input[name=option]').change(updatePromoCode)

updatePromoCode = ->
  $('.applepay-promo-code a').attr('href',getConfirmationUrl())

ApplePay.init = (payload, done) ->
  if ApplePayUI.hasValidConfirmationLink $('a.buy-button:first')[0]?.href
    ApplePayUI.start payload, getTotalAmount, getApplePayButton, renderApplePayFeature, updatePromoCodeHandler, getConfirmationUrl, 'SpyglassDesktopDealsPage'
  done()

module.exports = ApplePay



// WEBPACK FOOTER //
// ./modules/applepay/desktop2016/frontend/main.coffee